import { Injectable } from "@angular/core";
import { Http, Headers, URLSearchParams } from "@angular/http";
import 'rxjs/add/operator/toPromise';
import { environment } from "../../environments/environment";
import { AppService } from "../app.service";

@Injectable()
export class LayoutPrintService {

    apiUrl: String;
    jwt: String;
    constructor(private http: Http, private appService: AppService) {
        this.apiUrl = environment.apiUrl;
        this.jwt = appService.getJwt();
    }

    getLayoutPrintList(filterParams: any) {
        const url = this.apiUrl + 'api/cms/layout-print/list';
        const headers = new Headers();
        headers.append('X-Authorization', 'Bearer ' + this.jwt);
        headers.append('Content-Type', 'application/json');

        const params = new URLSearchParams();
        params.append("page", filterParams.page);
        params.append("size", filterParams.size);
        return this.http.get(url, { headers, params })
            .toPromise()
            .then(res => res.json())
            .then(resJson => resJson);
    }

    deleteLayoutPrint(id: string) {
        const url = this.apiUrl + 'api/cms/layout-print/delete/' + id;
        const headers = new Headers();
        headers.append('X-Authorization', 'Bearer ' + this.jwt);
        headers.append('Content-Type', 'application/json');
        return this.http.delete(url, { headers })
            .toPromise()
            .then(res => res.json())
            .then(resJson => resJson);
    }
}


// WEBPACK FOOTER //
// /build/client-cms/src/app/layout-print/layout-print.service.ts